import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CommonModalV2, { modalWidth } from "./commonModal/v2";
import ModalExitAlert from "./modalExitAlert";
import Button from '@material-ui/core/Button';
import TextPatientStyle from "../../styles/textPatientStyle";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const SubmitButtonRef = React.createRef();

class TextPatient extends React.Component {
    state = {
        templateError: false,
        exitModalOpen: false
    }
    componentDidMount() {
        let data = {
            "DoctorId": localStorage.getItem('userId') && parseInt(localStorage.getItem('userId')),
            "OrderId": this.props.productInfo.OrderId
        }
        this.props.GetTextPatientTemplates && this.props.GetTextPatientTemplates(data);
    }

    UNSAFE_componentWillUnmount() {
        let { ResetTextPatientDetails } = this.props;
        ResetTextPatientDetails && ResetTextPatientDetails();
    }

    handleTemplateChange = (e) => {
        let { HandleGlobalValueChange, textmessageTemplateData } = this.props;
        let { name, value } = e.target;
        let messageText = "";
        for (let i = 0; i < textmessageTemplateData.length; i++) {
            if (textmessageTemplateData[i].TemplateId === value) {
                messageText = textmessageTemplateData[i].TemplateText;
                break;
            }
        }
        if (value === -1 || value === "-1" || value === "") {
            this.setState({ templateError: true })
        } else {
            this.setState({ templateError: false })
        }
        HandleGlobalValueChange && HandleGlobalValueChange({ value, name });
        HandleGlobalValueChange && HandleGlobalValueChange({ value: messageText, name: "messageValue" });
    }

    onTextPatientButtonClick = () => {
        let { TextPatient,selectedCardData, productInfo = {}, textMessageTemplateValue } = this.props;
        let data = {
            "OrderId": productInfo.OrderId,
            "PatientId": selectedCardData.UserId,
            "TemplateId": textMessageTemplateValue
        };
        if (SubmitButtonRef && SubmitButtonRef.current) {
            SubmitButtonRef.current.blur && SubmitButtonRef.current.blur();
        }
        TextPatient && TextPatient(data);
    }

    openAlertModal = () => {
        this.setState({ exitModalOpen: true });
    }

    closeAlertModal = () => {
        this.setState({ exitModalOpen: false });
    }

    onConfirmation = () => {
        let { closeTextPatient, ResetCallPatientDetails } = this.props;
        this.setState({ exitModalOpen: false });
        ResetCallPatientDetails && ResetCallPatientDetails();
        closeTextPatient && closeTextPatient();
    }

    render() {
        let {
            openTextPatient,
            classes,
            isModalAlertOpen,
            SetModalAlertOpen,
            textMessageTemplateValue = -1,
            textmessageTemplateData = [],
            messageValue = "",
            HandleGlobalValueChange
        } = this.props;
        return (
            <CommonModalV2 onGlobalValueChange={HandleGlobalValueChange} id="CallPatientModal" title="Text Patient" open={openTextPatient} toggleModal={this.openAlertModal} style={{ width: modalWidth.l }}>
                <div data-view="text-to-patient-component-wrapper" className={classes.modalBody}>
                    <div className={`${classes.contentWrapper}`}>
                        <div className={classes.mainTitleText}>Template</div>
                        <FormControl variant="outlined" className={this.state.templateError ? classes.templateInputError : classes.templateInput}>
                            <Select
                                labelId="customized-select-label"
                                id="template"
                                MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList } }}
                                classes={{ outlined: classes.productSelectStyle }}
                                value={textMessageTemplateValue}
                                name={"textMessageTemplateValue"}
                                onChange={this.handleTemplateChange}
                                onBlur={this.handleReasonBlur}
                                label={void 0}
                            >
                                <MenuItem
                                    title={"-- Choose --"}
                                    classes={{ selected: classes.menuItemSelected }}
                                    className={classes.menuItemRoot}
                                    value={-1}>
                                    -- Choose --
                                </MenuItem>
                                {textmessageTemplateData && textmessageTemplateData.map((_, index) => {
                                    return <MenuItem
                                        title={_.TemplateTitle}
                                        classes={{ selected: classes.menuItemSelected }}
                                        className={classes.menuItemRoot}
                                        key={index + _.TemplateTitle}
                                        value={_.TemplateId}>
                                        {_.TemplateTitle}
                                    </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className={`${classes.contentWrapper} ${classes.extraContentWrapperStyle}`}>
                        <div className={classes.mainTitleText}>Message</div>
                        <div className={classes.messageStyle}>{messageValue}</div>
                    </div>
                    <div className={classes.modalActionWrapper}>
                        <Button
                            disabled={textMessageTemplateValue === -1 || textMessageTemplateValue === "-1" || textMessageTemplateValue === "" || !messageValue}
                            onClick={this.onTextPatientButtonClick}
                            variant="contained" color="primary"
                            ref={SubmitButtonRef}
                            id="callToPatientButton"
                            className={classes.buttonStyle}>
                            Send Message
                        </Button>
                        <Button
                            onClick={this.openAlertModal}
                            variant="contained"
                            color="primary"
                            id="cancalCallToPatientButton"
                            className={classes.cancelButtonStyle}>
                            Cancel
                        </Button>
                    </div>
                </div>
                <ModalExitAlert type="confirmation" onConfirmation={this.onConfirmation} modalOpen={this.state.exitModalOpen} closeModal={this.closeAlertModal} />
                <ModalExitAlert type="alert" modalOpen={isModalAlertOpen} closeModal={() => SetModalAlertOpen(false)} />
            </CommonModalV2>
        )
    }
}


export default withStyles(TextPatientStyle)(TextPatient);

